import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ClienteUsuarioModel } from '../../models/auth/cliente-usuario.model';
import { UsuarioWebModel } from '../../models/auth/usuario-web.model';
import { ConfigService } from '../config.service';
import { NO_SEND_HEADER } from './../../interceptors/header.service';
@Injectable({
  providedIn: 'root'
})
export class UsuarioService {

  private baseUrl = this.configService.config.servidor?.api_server;
  constructor(private http: HttpClient,
    public configService: ConfigService,) { }

    // SC CATFER-9 definir funcion getUsuarioWeb (id_usuario_web, token), para obtener todos los datos del usuario web que se intenta loguear.
    getUsuarioWeb(idUsuarioWeb: number, accessToken?: string){
      // const url = `${this.baseUrl}/UsuarioWeb/${idUsuarioWeb}`;
      // MC CATFER-94 Uso las referencias al archivo resource.json
      const url = this.baseUrl + this.configService.resource.USUARIO_WEB.GET_USUARIO_WEB.VERSION + this.configService.resource.USUARIO_WEB.PATH_BASE + this.configService.resource.USUARIO_WEB.GET_USUARIO_WEB.PATH_REL.replace('{id_usuario_web}', idUsuarioWeb);
      if(accessToken){
        const headers = new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`
        });
        // SC CATFER-9 caso se pase el token como parametro no se debe añadir otro en el Interceptor.
        return this.http.get<UsuarioWebModel>(url, { headers: headers, context: new HttpContext().set(NO_SEND_HEADER, true) });
        // .pipe(
        //   map((resp) => {
        //     if(resp.Data){
        //       resp.Data.PlataformaIntegracion.ModoPorSucursal = 'S';
        //     }
        //     return resp;
        //   })
        // );
      }else{
        // SC CATFER-9 caso que se desea que el interceptor añada el token ya obtenido y almacenado.
        return this.http.get<UsuarioWebModel>(url);
      }
  
     
    }
  
    // SC CATFER-9 definir  funcion getClientes(id_usuario_web, token): funcion obtiene los cliente asociados para un usuario web.
    getClientes(idUsuarioWeb: number, accessToken?: string){
      // const url = `${this.baseUrl}/UsuarioWeb/${idUsuarioWeb}/ObtenerCliente`;
      // MC CATFER-94 Uso las referencias al archivo resource.json
      const url = this.baseUrl + this.configService.resource.USUARIO_WEB.GET_CLIENTES.VERSION + this.configService.resource.USUARIO_WEB.PATH_BASE + this.configService.resource.USUARIO_WEB.GET_CLIENTES.PATH_REL.replace('{id_usuario_web}', idUsuarioWeb);
      if(accessToken){
        const headers = new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`
        });
        // SC CATFER-9 caso se pase el token como parametro no se debe añadir otro en el Interceptor.
      return this.http.get<ClienteUsuarioModel>(url, { headers: headers, context: new HttpContext().set(NO_SEND_HEADER, true) });
    }else{
      // SC CATFER-9 caso que se desea que el interceptor añada el token ya obtenido y almacenado.
      return this.http.get<ClienteUsuarioModel>(url);
    }
  }
}
